export default __webpack_public_path__ + "media/images/carnival/destination_2_rj-7107b3da939191127375579de11f38dc.jpg";